import { pick } from 'lodash';
import {
  REQUEST_SERVICES,
  RECEIVE_SERVICES,
  REQUEST_SERVICE,
  RECEIVE_SERVICE,
  ALL_SERVICES_FETCHED,
  ANY_BARBER,
} from '../constants';
import {
  checkStatus,
  handleRequestError,
  checkRoute,
  nullFunc,
} from '../utils/helpers';
import config from '../../config';

function requestServices() {
  return { type: REQUEST_SERVICES };
}

export function receiveServices(services) {
  return {
    type: RECEIVE_SERVICES,
    payload: services,
  };
}

function serviceUrl(shopRoute, barberRoute, filter = '') {
  const baseUrl = `${config.url}/shop/${shopRoute}/`;
  const shouldGetBarberServices = barberRoute && barberRoute !== ANY_BARBER;
  const barberUrl = shouldGetBarberServices ? `barber/${barberRoute}/` : '';
  return `${baseUrl}${barberUrl}service${filter}`;
}

const fetchServicesAction = dispatch => (url, redirectParams, urlPattern) => fetch(url)
  .then(checkRoute(dispatch, redirectParams, urlPattern))
  .then(checkStatus)
  .then(services => dispatch(receiveServices(services)))
  .catch(handleRequestError(dispatch));

export function fetchServices(shopRoute, barberRoute, params, urlPattern, kiosk) {
  return (dispatch) => {
    if (!shopRoute) return Promise.resolve();

    dispatch(requestServices());

    return fetchServicesAction(dispatch)(
      serviceUrl(shopRoute, barberRoute, `?sortBy=order&limit=500${kiosk ? '&kiosk=true' : ''}`),
      pick(params, ['shopRoute']),
      urlPattern
    );
  };
}

function requestService(id) {
  return {
    type: REQUEST_SERVICE,
    id,
  };
}

function receiveService(service) {
  return {
    type: RECEIVE_SERVICE,
    payload: service,
  };
}

function shouldFetchService(state, id) {
  if (!state.services) return true;
  return !state.services.get('items').find(service => service.get('id') === id);
}

export function fetchService(shopRoute, barberRoute, serviceId, params, urlPattern) {
  return (dispatch, getState) => {
    if (!serviceId || !shouldFetchService(getState(), serviceId)) return Promise.resolve();

    dispatch(requestService(serviceId));

    const url = `${serviceUrl(shopRoute, barberRoute)}/${serviceId}`;
    const redirectParams = pick(params, ['shopRoute', 'barberRoute']);

    return fetch(url)
      .then(checkRoute(dispatch, redirectParams, urlPattern))
      .then(checkStatus)
      .then(service => dispatch(receiveService(service)))
      .catch(error => Promise.reject(handleRequestError(dispatch)(error)));
  };
}

export function fetchSelectedServices(shopRoute, barberRoute, servicesIds, params, urlPattern) {
  return (dispatch) => {
    if (!servicesIds) return Promise.resolve();

    const services = servicesIds.split(';')
      .map(serviceId => dispatch(fetchService(shopRoute, barberRoute, serviceId, params, urlPattern)));

    return Promise.all(services)
      .then(() => dispatch({ type: ALL_SERVICES_FETCHED }))
      // Error dispatching is handled in individual fetch function
      .catch(nullFunc);
  };
}



// WEBPACK FOOTER //
// ./src/app/services/actions.js